import CustomZObject from './CustomZObject.js';
import {TIDALS} from 'messaging/message-types.js';

export default class JakiSnapshots extends CustomZObject {
    constructor(zobject) {
        super(zobject);
        this.snapshots = [];
        this.newInlet("cursor", ([x,y]) => this.cursor = [x,y]);
        this.newInlet(TIDALS, ([tidals]) => {
            this.tidals = tidals;
        });
        this.newInlet("take snapshot", (msg) => this.takeSnapshot(msg));
        this.newInlet("use snapshot", ([msg]) => this.useSnapshot(msg));
        this.newOutlet("cursor");
    }

    takeSnapshot() {
        if (!this.tidals || !this.cursor) {
            return;
        }

        let tidals = [];
        for (let tidal of this.tidals) {
            let cycle = tidal.cycle;
            let cycleLength = tidal.cycleLength;
            tidals.push([cycle, cycleLength]);
        }
        this.snapshots=[...this.snapshots, {tidals, cursor: this.cursor}];
    }

    useSnapshot(number) {
        let snapshot = this.snapshots[number];
        if (!snapshot) {
            return;
        }
        /*
        for (let i=0; i < snapshot.tidals.length; i++) {
            let [cycle, cycleLength] = snapshot.tidals[i];
            this.tidals[i].cycleParameter.set(cycle);
            this.tidals[i].cycleLengthParameter.set(cycleLength);
        }
        */
        this.sendMessage("cursor", ... snapshot.cursor);
    }
}
